import { render, staticRenderFns } from "./CmgOrderConfirmationJoinLoyalty.vue?vue&type=template&id=7404bc36&scoped=true&lang=pug&"
import script from "./cmg-order-confirmation-join-loyalty.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-confirmation-join-loyalty.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderConfirmationJoinLoyalty.vue?vue&type=style&index=0&id=7404bc36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7404bc36",
  null
  
)

export default component.exports